import { injectGlobal } from '@emotion/css';
import emotionReset from 'emotion-reset';

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
injectGlobal`
  ${emotionReset}
`;
